/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';

class workflowItemModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("reviewItem");
        this.context = context;
        this.guid = ko.observable(this.context.util.guid());
        this.visible = ko.observable(false);
        this.editStatus = ko.observable(true);
        this.name = ko.observable("");
        this.title = ko.observable("");
        this.role = ko.observable("");
        this.status = ko.observable("");
        this.statusid = ko.observable(0);
        this.statusCSS = ko.observable("");
        this.data;
        this.parent;
        this.workflowIndex;

        this.editorVisible = ko.observable(true);

        //time to Display
        this.displayReviewTimes = ko.observable();
        this.startTimeFormated = ko.observable();
        this.endTimeFormated = ko.observable();
        this.elapsedTime = ko.observable();


        //console.log("workflowItemModel");
        //console.log(params);

        if(params)
        {
            this.init(params);
        }
        
    }

    init(params)
    {
        console.log("review-item:init: Console Review and Approve Items");
        console.log(params);
        this.data = params.data;
        this.parent = params.parent;
        this.workflowIndex = params.index();
        this.name(this.data.name());
        this.title(this.data.title());
        this.status(this.data.status());
        this.statusid(this.data.statusid());
        this.statusCSS(this.data.statusCSS());
        this.role(this.data.role());
        this.guid(this.data.guid());

        this.displayReviewTimes = params.data.displayReviewTimes;
        this.startTimeFormated = params.data.startTimeFormated;
        this.endTimeFormated = params.data.endTimeFormated;
        this.elapsedTime = params.data.elapsedTime;

        console.log("review-item:init: params: %o", params);

        if(this.context.loginStatusObj().Mode == "Review")
        {
            this.editorVisible(false);
        }
        else
        {
            this.editorVisible(true);
        }
        
    }

    editThis(jobObj) {
        //console.log("jobObj");
        //console.log("EditThis");
        context.eventManager.notifySubscribers({"workflowItem":this,"jobObj":jobObj},"review-Object-Modal");
    }

}

export default { viewModel: workflowItemModel, template: require('!raw-loader!./review-item.html') };


// WEBPACK FOOTER //
// ./src/components/review/review-item/review-item.js